// 初始化数据
const modal = {
  selectedRow: [],
  searchResult: [], //查询结果数据
  tableDatasource: [], //table datasource数据
  searchParams: {}, // 搜索存值
  searchJson: {}, //搜索传值
  orderDetailData: {}, //订单详情接口返回数据
  tabkey: '0', //table对应key值
  total: 0, // 查询总数
  page: 1, // 当前页码
  size: 10, // 当前分页数
  tableLoading: false, // 列表loading
  action: '', //是否是编辑或者新增
  isShowSearch: false, //是否显示高级查询
  selectedRowKeys: [], //选择的行,
  orderNums: [], //订单数量统计
  orderORgoods: '1', //1是订单层级(默认) 2是商品层级
  exportQuery: {}, //查询列表时保存请求参数
  tabList: [
    { name: '待发货', num: '0' },
    { name: '已发货', num: '0' },
    { name: '待核销', num: '0' },
    { name: '已核销', num: '0' },
    { name: '已取消', num: '0' },
  ],
  totalAmount: {},
  orderStatusList: [
    { name: '所有订单', key: '1' },
    { name: '未出库', key: '2' },
    { name: '已出库', key: '3' },
    { name: '已取消', key: '4' },
  ],
  orderStatusTurn: {
    3: '待发货',
    4: '已发货',
    5: '已签收',
    6: '已取消',
    11: '部分发货',
  },
  orderStatusKey: {
    0: '3', //待发货
    1: '4', //已发货
    2: '7', //待核销
    3: '8', //已核销
    4: '6', //已取消
  },
  submitLoading: false,
  orderList: [],
};
export default modal;
